import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const RedoLiner24 = ()=>/*#__PURE__*/ _jsx("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M16.87 18.31H8.87C6.11 18.31 3.87 16.07 3.87 13.31C3.87 10.55 6.11 8.31 8.87 8.31H19.87M17.57 10.81L20.13 8.25L17.57 5.69",
            stroke: "currentColor",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
